import { z } from 'zod';
import { resourceVisibilitySchema } from './resource.js';

export const dashboardCategoryBucketSchema = z.object({
  category: z.string(),
  name: z.string(),
  icon: z.string(),
  count: z.number().int().nonnegative(),
});
export type DashboardCategoryBucket = z.infer<typeof dashboardCategoryBucketSchema>;

export const dashboardTopClickedSchema = z.object({
  id: z.string(),
  title: z.string(),
  url: z.string(),
  clicks: z.number().int().nonnegative(),
  category: z.string(),
  icon: z.string(),
});
export type DashboardTopClicked = z.infer<typeof dashboardTopClickedSchema>;

export const dashboardVisibilityBucketSchema = z.object({
  visibility: resourceVisibilitySchema,
  count: z.number().int().nonnegative(),
});
export type DashboardVisibilityBucket = z.infer<typeof dashboardVisibilityBucketSchema>;

export const dashboardCreatedDayBucketSchema = z.object({
  date: z.string(),
  count: z.number().int().nonnegative(),
});
export type DashboardCreatedDayBucket = z.infer<typeof dashboardCreatedDayBucketSchema>;

export const dashboardStatsResponseSchema = z.object({
  totalResources: z.number().int().nonnegative(),
  activeResources: z.number().int().nonnegative(),
  totalCategories: z.number().int().nonnegative(),
  totalClicks: z.number().int().nonnegative(),
  byCategory: z.array(dashboardCategoryBucketSchema),
  topClicked: z.array(dashboardTopClickedSchema),
  byVisibility: z.array(dashboardVisibilityBucketSchema),
  createdLast30Days: z.array(dashboardCreatedDayBucketSchema),
});
export type DashboardStatsResponse = z.infer<typeof dashboardStatsResponseSchema>;
